import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import { jsonHeader, isProdEnv, serverUrl } from '../../../config';
import { SiteName } from '../../../shared/components/domainSupport';
import LoadingSpinner from '../../../shared/components/widgets/LoadingSpinner';

const OAuthPage = () => {
  const user = useSelector(store => store.authentication.user);
  const supportText = SiteName() === 'Limitless' ? <h4>For onboarding support, please contact <a href="mailto:adteam@limitless.tech">adteam@limitless.tech</a></h4> : '';
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const state = urlParams.get('state');
  const sellerId = urlParams.get('sellerId');
  const type = urlParams.get('type');
  const partnerType = urlParams.get('partnerType');
  const clientId = urlParams.get('clientId');
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const headerWithAuth = { ...jsonHeader, authorization: `JWT ${user?.jwtToken}` };
    // Add logic to check input values, make sure they are present and correct.
    const onboardStartOptions = {
      method: 'POST',
      headers: headerWithAuth,
      body: JSON.stringify({
        code,
        state,
        sellerId,
        type,
        partnerType,
        clientId,
      }),
    };

    const onboardFinishUrl = `${serverUrl}/onboarding/walmart/mp-api/finish`;
    fetch(onboardFinishUrl, onboardStartOptions)
      .then(async (results) => {
        if (!results.ok) {
          const text = await results.text();
          throw new Error(text);
        }
        return results.json();
      }).then((data) => {
        if (!isProdEnv) {
          console.info(data);
        }
        if (data.status === 'SUCCESS') {
          setSuccess(true);
          setMessage('SUCCESS - We have added the Walmart Marketplace API to your account');
        } else {
          setMessage('We are having issues processing your request, please try again later. ERROR 00001');
        }

        setLoading(false);
      }).catch((error) => {
        try {
          const serverMsg = JSON.parse(JSON.parse(error.message).error).error;
          setMessage(`Server Error: ${serverMsg}`);
        } catch {
          setMessage('We are having issues processing your request, please try again later. ERROR 00002');
        }
        setLoading(false);
      });
  }, []);

  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">API Onboarding and Maintenance</h3>
          <h5>This flow can be used to add or renew your authorization on an existing account.</h5>
        </Col>
      </Row>
      <Row>
        <br />
      </Row>
      <LoadingSpinner
        active={loading}
      />
      {!loading && success && (
        <Row>
          <Col md={6}>
            <div className="account__wrapper">
              <h4>{message}</h4>
              <br />
              <p>Seller ID: {sellerId}</p>
              <p>Type: {type}</p>
              <p>Partner Type: {partnerType}</p>
              <br />
              {supportText}
              <br />
              <h4>Thank You</h4>
            </div>
          </Col>
        </Row>
      )}
      {!loading && !success && (
        <Row>
          <Col md={6}>
            <div className="account__wrapper">
              <h4>{message}</h4>
              <br />
              {supportText}
              <br />
              <h4>Thank You</h4>
            </div>
          </Col>
        </Row>
      )}
      <Row>
        <br />
      </Row>
    </Container>
  );
};

export default OAuthPage;
